import { Injectable } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Injectable({
    providedIn: 'root',
})
export class StepperService {
    private stepper: MatStepper | null = null;

    setStepper(stepper: MatStepper) {
        this.stepper = stepper;
    }

    getCurrentStepIndex(): number {
        return this.stepper ? this.stepper.selectedIndex : 0;
    }

    getStepper(): MatStepper | null {
        return this.stepper;
    }

    next(): void {
        this.stepper?.next();
    }
}
